import { ApiClient } from '../api-client';

export class RatesEngineEndpoint {
  constructor(private api: ApiClient) {

  }
}

export interface RatesPayload {
  rates: {
    productId: number;
    rate: {
      currency: string;
      amount: number;
    },
    error?: string;
  }[];
}
